/**
 * Os motivos de aviso de tarifa que o modal-session escreve no lugar da frase
 * de prazo do hotels-api (`cancelation_policy_startDate_change`).
 *
 * A frase do fornecedor não serve para a tela: a data sai crua (`29-09-2026`),
 * é o início da PRIMEIRA janela da política seja qual for a multa dela, e já
 * chegou no passado (C3, prod 29/09/2026). O modal-session a confronta com a
 * política da busca e o reembolso confirmado, e publica um destes códigos — ou
 * nenhum, quando o aviso era falso. Quem humaniza é `hotelRateWarningReasons`.
 *
 * Moram na raiz do kit (sem React) porque o modal-session produz e o kit lê.
 */

/** A tarifa confirmada ficou não reembolsável. */
export const HOTEL_RATE_WARNING_NON_REFUNDABLE = 'non_refundable';

/** O prazo sem multa já passou: cancelar a partir de agora gera multa. */
export const HOTEL_RATE_WARNING_FREE_CANCELLATION_ENDED = 'free_cancellation_ended';

const FREE_CANCELLATION_UNTIL_PREFIX = 'free_cancellation_until:';

/** O prazo sem multa mudou para `date` (ISO `YYYY-MM-DD`, futuro). A data
 *  viaja dentro do código porque os dois leitores (bancada e card do chat)
 *  só recebem a lista de motivos. */
export function hotelRateWarningFreeCancellationUntil(date: string): string {
  return `${FREE_CANCELLATION_UNTIL_PREFIX}${date}`;
}

/** A data de um código `free_cancellation_until:…`, ou `undefined` para
 *  qualquer outro motivo. */
export function freeCancellationUntilOfWarning(warning: string): string | undefined {
  if (!warning.startsWith(FREE_CANCELLATION_UNTIL_PREFIX)) return undefined;
  const date = warning.slice(FREE_CANCELLATION_UNTIL_PREFIX.length);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : undefined;
}
